import CheckboxFacet from '@/components/facets/CheckboxFacet.vue';
import SelectFacet from '@/components/facets/SelectFacet.vue';

export default {
  components: {
    CheckboxFacet,
    SelectFacet,
  },
  props: {
    metrics: {
      type: Object,
      default: () => {},
    },
    selections: {
      type: Array,
      default: () => [],
    },
    itemText: {
      type: String,
      default: 'name',
    },
    itemCount: {
      type: String,
      default: 'count',
    },
    itemValue: {
      type: String,
      default: 'id',
    },
  },
  methods: {
    updateSelection(values) {
      const filter = { id: this.filterId, type: this.filterType };
      const selection = this.getFormattedSelection(values);
      this.$emit('change', { filter, selection });
    },
  },
  computed: {
    formattedValues() {
      const selection = this.selections.find(it => it.filter && it.filter.id === this.filterId );
      return selection ? this.getFormattedValues(selection.selection) : [];
    },
  },
}